import { useState } from 'react'
import { Button } from '../ui'

/** A search box that searches on submit, for admin lists. */
export function SearchForm({ placeholder, label, onSearch }: { placeholder: string; label: string; onSearch: (query: string) => void }) {
  const [draft, setDraft] = useState('')
  return (
    <form
      className="row"
      onSubmit={(event) => {
        event.preventDefault()
        onSearch(draft.trim())
      }}
    >
      <input className="input-medium" value={draft} onChange={(event) => setDraft(event.target.value)} placeholder={placeholder} aria-label={label} />
      <Button type="submit" variant="secondary">
        Search
      </Button>
    </form>
  )
}
